import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class ReportFile extends ApplicationRecord {
  static jsonapiType = "report_files";

  @Attr({ persist: false }) createdAt: string;

  @Attr() fileType: string;

  @Attr() identifier: string;

  @Attr() name: string;

  @Attr() url: string;
}

export default ReportFile;
